module.exports = __webpack_public_path__ + "static/media/Master_Account.cdc0e593.svg";